<template>
<div>
  <body>
    <!-- <svg class="blob" id="blob" viewBox="0 0 1920 3000" xmlns="http://www.w3.org/2000/svg">
      <path id="blob-path-3" transform="translate(974.58,767.88) rotate(-400) scale(0.001)" />
      <path id="blob-path-2" transform="translate(932.84,695.15) rotate(-400) scale(0.001)" />
      <path id="blob-path-1" transform="translate(888.72,629.18) rotate(-400) scale(0.001)" />
    </svg>-->
    <div class="nav">
      <d-link class="nav-logo mobile-align" to="/">
        <img src="@/assets/images/spring-logo.svg" alt="spring logo" />
      </d-link>
      <ul class="nav-list reset-ul ml-auto">
        <li class="nav-item">
          <a class="nav-link" data-id="features" href="#features">{{ $t("landing.nav.features") }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-id="pricing" href="#pricing">{{ $t("landing.nav.pricing") }}</a>
        </li>
        <li>
          <language-switcher />
        </li>
        <li class="nav-item login-align mobilehidden2">
          <router-link :to="{ name: 'login' }">
            <a class="align-login btn btn-login btn-green">{{ $t("landing.nav.login") }}</a>
          </router-link>
        </li>
      </ul>
    </div>
    <main>
      <header class="container text-sm-center hero">
        <section class="row">
          <div class="col-12">
            <h1 class="section-hero" style="white-space: pre;">{{ $t("landing.jumbotron.title") }}</h1>
            <p class="section-subtitle">
              {{ $t("landing.jumbotron.subtitle") }}
              <br />
            </p>
            <d-link to="register" class="btn btn-signup btn-green">
              {{
              $t("landing.jumbotron.cta-button")
              }}
            </d-link>
            <div class="subtext mb-4">{{ $t("landing.jumbotron.cta-subtext") }}</div>
          </div>
          <div class="col-12">
            <img class="hero-img" alt="dashboard" src="@/assets/images/landing/spring_app.png" />
          </div>
        </section>
      </header>
      <section class="container">
        <div class="row" id="features">
          <div class="col-sm-12 col-lg-6">
            <h2 class="section-title">{{ $t("landing.features.title") }}</h2>
            <p class="section-subtitle">{{ $t("landing.features.description") }}</p>
          </div>
          <div class="col-sm-12 col-lg-6">
            <img alt="find new customers" src="@/assets/images/landing/ideal_customer.png" />
          </div>
        </div>
        <div class="row">
          <LeadExample />
        </div>
      </section>
      <section class="container">
        <div class="row">
          <div class="col-sm-12 col-lg-6 order-1 order-lg-2">
            <h2 class="section-title">{{ $t("landing.features.title2") }}</h2>
            <p class="section-subtitle">{{ $t("landing.features.description2") }}</p>
          </div>
          <div class="col-sm-12 col-lg-6 order-2 order-lg-1">
            <img alt="Send the right message" src="@/assets/images/landing/template_editor.png" />
          </div>
        </div>
      </section>
      <section class="container">
        <div class="row">
          <div class="col-sm-12 col-lg-6">
            <h2 class="section-title" style="white-space: pre;">{{ $t("landing.features.title3") }}</h2>
            <p class="section-subtitle">{{ $t("landing.features.description3") }}</p>
          </div>
          <div class="col-sm-12 col-lg-6">
            <img alt="template editor" src="@/assets/images/landing/dashboard.png" />
          </div>
        </div>
      </section>
      <!-- <section class="container">
        <div class="row">
          <div class="col-sm-12 col-lg-6 order-1 order-lg-2">
            <h2 class="section-title">{{ $t("landing.features.title4") }}</h2>
            <p
              class="section-subtitle"
            >{{ $t("landing.features.description4") }}</p>
          </div>
          <div class="col-sm-12 col-lg-6 order-2 order-lg-1">
            <img alt="AI makes you smarter" src="@/assets/images/landing/dashboard.png" />
          </div>
        </div>
      </section>-->
      <!-- Pricing Box -->
      <PricingBox />
      <!-- / Pricing Box -->
      <section class="cta-bottom">
        <div class="container">
          <div class="col-sm-12">
            <h2 class="section-title text-black">{{ $t("landing.pricing.title") }}</h2>
            <p class="section-subtitle text-black">{{ $t("landing.pricing.description") }}</p>
            <div class="mx-lg-auto">
              <d-link to="register" class="btn btn-signup btn-green">
                {{
                $t("landing.jumbotron.cta-button")
                }}
              </d-link>
              <div class="subtext">{{ $t("landing.jumbotron.cta-subtext") }}</div>
            </div>
          </div>
        </div>
      </section>
    </main>
    <footer class="footer">
      <div class="container footer-wrap">
        <ul class="footer-list">
          <li class="footer-item">
            <a
              class="footer-link"
              target="_blank"
              href="/privacy"
            >{{ $t("landing.footer.privacy") }}</a>
          </li>
          <li class="footer-item">
            <a class="footer-link" target="_blank" href="/terms">{{ $t("landing.footer.terms") }}</a>
          </li>
          <li class="footer-item">
            <a
              class="footer-link"
              target="_blank"
              href="https://www.enzymelabs.co/team"
            >{{ $t("landing.footer.about") }}</a>
          </li>
          <li class="footer-item">
            <a
              class="footer-link"
              target="_blank"
              href="https://spring.kampsite.co"
            >{{ $t("landing.footer.roadmap") }}</a>
          </li>
        </ul>
        <div class="footer-text">
          Made just for you by
          <strong>
            &copy;
            <a class="color-link" target="_blank" href="https://enzymelabs.co">
              <strong>Enzyme Labs</strong>
            </a>
          </strong>
        </div>
      </div>
    </footer>
  </body>
</div>
</template>

<script>
import PricingBox from "@/components/common/PricingBox.vue";
import LanguageSwitcher from "@/components/common/LanguageSwitcher.vue";
import LeadExample from "@/components/common/LeadExample.vue";
// import Kutesvg from "@/utils/kute-svg.js";
// import Kute from "@utils/kute.js";
// import Blob from "@/utils/blob.js";

export default {
  components: {
    PricingBox: PricingBox,
    LanguageSwitcher,
    LeadExample
  },
  data() {
    return {};
  }
};
</script>

<style type="scss" scoped>
@import "https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,600&display=swap";

@media (max-width: 564px) {
  .mobilehidden2 {
    display: none !important;
  }
}

.align-login {
  margin-top: 18px !important;
}

.langPosition {
  margin-right: 24px !important;
  margin-top: 25px;
}

html {
  text-size-adjust: 100%;
  box-sizing: border-box;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: transparent;
  overflow-x: hidden;
  overflow-y: scroll !important;
  scroll-behavior: smooth !important;
}

body {
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, sans-serif !important;
  margin: 0px !important;
  padding-top: 145px !important;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #3d5170 !important;
  text-align: left;
  background-color: white !important;
}

h1,
h2,
h3,
h4,
h5,
h6,
p,
.nav {
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, sans-serif !important;
  color: #222 !important;
}

@media (max-width: 767px) {
  .mobile-align {
    display: block;
    width: 100%;
    margin: 0 auto;
    padding-top: 20px;
  }
  .login-align {
    display: block;
    width: 100% !important;
    margin: 0 auto;
  }
}

.container {
  padding-right: 20px;
  padding-left: 20px;
}

section {
  margin-top: 6.8rem !important;
  margin-bottom: 6.8rem !important;
}

/* Footer */
footer {
  display: block;
  padding: 40px 40px;
  margin: 0 auto;
  line-height: 2;
}

.hero-img {
  max-width: 900px !important;
  padding: 0 20px 0 30px;
  margin-top: 10px !important;
  width: 100%;
}

.color-link {
  background-color: transparent;
  transition-delay: 0s;
  transition-duration: 0.25s;
  transition-property: all;
  transition-timing-function: ease-out;
  box-shadow: #5cc72a inset 0 -1px 0 0;
}

.color-link:hover {
  box-shadow: #5cc72a 0 -1px 0 0 inset;
  box-shadow: #ff0 0 -20px 0 0 inset;
  text-decoration: none;
  color: #222;
}

.footer-wrap {
  text-align: center;
  margin: 0 auto;
}

.footer-title {
  box-sizing: border-box;
  font-size: 4.0625rem;
  font-weight: 900;
  line-height: 4.625rem;
  margin: 0 auto 2.5rem;
  max-width: 620px;
}

.footer-list {
  list-style: none;
  padding: 0;
  margin-bottom: 15px;
}

.footer-item {
  font-size: 16px;
  letter-spacing: 0.5px;
  line-height: 2;
  display: inline;
  margin: 0 15px;
}

.footer-item:hover {
  color: var(--green) !important;
}

.footer-item:not(:last-child) {
  margin-bottom: 10px;
}

.footer-text {
  font-size: 16px;
}

header,
main,
nav {
  display: block;
}

section {
  display: block;
  margin-top: 80px;
  margin-top: 80px;
}

::selection {
  background: #00bbff50;
}

h1,
h2,
h3,
p {
  margin-bottom: 1.5rem;
}

img {
  width: 100%;
  margin: 0 auto !important;
  transition: all 0.2s ease-in-out;
}

.section-hero {
  text-align: center;
  font-size: 4.0625rem;
  font-weight: 600;
  line-height: 4.1rem;
  margin-bottom: 2.5rem;
}

.section-title {
  margin-top: 50px;
  font-size: 4.0625rem;
  font-weight: 600;
  line-height: 4rem;
  margin-bottom: 1.8rem;
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, sans-serif !important;
}

.section-subtitle {
  font-size: 22px;
  font-weight: 400;
  margin: 0 auto 2.5rem;
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, sans-serif !important;
}

p {
  font-size: 1.3rem;
}

ul {
  margin-top: 0;
  margin-bottom: 1rem;
}

a {
  text-decoration: none;
  background-color: transparent;
  color: #222;
}

a:hover,
a:focus {
  color: #00e156;
  text-decoration: none;
}

svg {
  overflow: hidden;
  vertical-align: middle;
}

.blob-wrap {
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
}

.blob {
  z-index: -1;
  position: fixed;
  top: -30px;
  left: 50%;
  width: 100%;
  height: 3000px;
  min-width: 1440px;
  pointer-events: none;
  transform: translate3d(-50%, 0, 0);
}

.text-black {
  color: black !important;
}

.btn {
  padding: 0.375rem 0.75rem;
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, sans-serif !important;
  color: #fff !important;
  width: 200px;
  max-width: 285px;
  transition: all 0.25s ease-in-out;
  border-radius: 50px;
  color: #fff;
  display: inline-block;
  font-size: 16px !important;
  font-weight: bold !important;
  letter-spacing: 2px !important;
  line-height: 2.5rem;
  text-align: center;
  text-transform: uppercase;
}

.btn:hover,
btn:focus {
  color: #fff !important;
  transform: translateY(-5px);
}

.btn-login {
  max-width: 115px !important;
  line-height: 1.9rem !important;
  margin-top: 16px;
}

.btn-signup {
  margin: 0 auto;
  display: block;
  width: 250px;
}

.btn-plan {
  position: absolute;
  bottom: -26px;
  left: 0;
  right: 0;
  margin: 0 auto;
}

.btn-green {
  background: #00e156;
}

.btn-green:hover,
.btn-green:focus {
  box-shadow: rgba(8, 255, 0, 0.5) 0 5px 20px;
}

.btn-blue {
  background-color: #007bff;
}

.btn-blue:hover,
.btn-blue:focus {
  box-shadow: rgba(0, 123, 255, 0.5) 0 5px 20px;
}

.btn-black {
  background-color: #222;
}

.btn-black:hover,
.btn-black:focus {
  box-shadow: rgba(34, 34, 34, 0.5) 0 5px 20px;
}

.reset-ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.cta-bottom {
  background: #fafafa;
  opacity: 0.85;
  padding-top: 5.5rem;
  padding-bottom: 5.5rem;
  text-align: center !important;
  margin-bottom: 0 !important;
  margin-top: 20px !important;
}

.text-black {
  margin-top: 0px !important;
}

.nav {
  font-size: 18px !important;
  margin-top: -400px;
  transition: all 0.2s ease-in-out;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.75);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  left: 0;
  border-radius: 50px;
  padding: 0 30px;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1;
  height: 100px;
  margin: 15px;
}

.nav-logo {
  width: 7.5rem;
  margin-top: 2px;
}

.nav-list {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.nav-link {
  font-size: 20px !important;
  font-size: 18px;
  line-height: 3;
  padding: 10px;
  text-transform: capitalize;
}

.plans {
  text-align: center;
  margin-bottom: 6.8rem;
}

.plan-title {
  font-size: 3.375rem;
  font-weight: 900;
  line-height: 3.8125rem;
  margin-bottom: 2.625rem;
  margin-top: 0;
  text-transform: uppercase;
  text-align: center;
}

.plan-text {
  color: #222 !important;
  font-size: 18px;
  line-height: 25px;
  margin-bottom: 20px;
  margin-top: 0;
  text-align: center;
}

.plan {
  margin-top: 4rem;
  text-align: center;
  display: inline-block;
}

.plan-sm {
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.14) 0 4px 3.125rem;
  padding: 3.125rem;
  position: relative;
  top: -25px;
  margin-right: -10px;
  width: 300px;
  background-color: #fff;
}

.plan-lg {
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.08) 0 4px 3.125rem;
  padding: 4rem 3.125rem;
  position: relative;
  width: 400px;
  background-color: #fff;
}

.plan-price {
  color: #007bff;
  font-size: 22px;
  font-weight: 600;
  line-height: 25px;
  margin: 0 0 35px;
  text-align: center;
}

.pricing-switch {
  -webkit-box-pack: center;
  display: flex;
  font-size: 22px;
  font-weight: 600;
  justify-content: center;
  line-height: 25px;
}

.pricing-switch-yearly {
  -webkit-box-align: start;
  -webkit-box-direction: normal;
  -webkit-box-orient: vertical;
  align-items: flex-start;
  display: flex;
  flex-direction: column;
}

.pricing-switch-monthly {
  color: #959ba3;
  font-size: 22px;
  font-weight: 600;
  text-align: right;
  margin-right: 14px;
}

.pricing-subtext {
  color: #959ba3;
  font-size: 16px;
  font-weight: 400;
}

.pricing-button {
  position: absolute;
  bottom: -30px;
  background-color: #007bff;
}

.pricing-button-small {
  position: absolute;
  bottom: -30px;
  width: 200px;
  background-color: #222;
}

@media (max-width: 767px) {
  .nav-logo {
    padding-top: 0px !important;
  }
  .section-title,
  .section-hero,
  .section-subtitle {
    transition: all 0.4s ease-in-out;
    font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont,
      sans-serif !important;
  }

  .section-title,
  .section-hero {
    font-size: 45px !important;
    line-height: 45px;
    text-align: center !important;
  }

  .section-subtitle {
    text-align: center !important;
  }
  .hero-img {
    margin-top: 30px !important;
    padding: 0px;
  }
}

@media (max-width: 621px) {
  .plan {
    margin: 80px auto 0px !important;
    width: 100% !important;
    display: block;
    position: relative;
    right: 0;
    padding: 3.125rem !important;
  }
  .nav {
    transition: all 0.2s ease-in-out;
    padding: 0px 15px;
    margin: 0px 0px;
    border-radius: 0;
    background-color: white;
  }
  .nav-link {
    padding: 10px 0px;
    margin: 0px 10px 0px 15px;
  }
  .section-hero {
    font-size: 2.3rem !important;
  }
  .hero .row {
    margin-top: 40px !important;
  }
  .nav {
    height: auto;
  }
}

@media (max-width: 534px) {
  ul {
    margin-left: 0 auto !important;
    text-align: center;
  }
}

@media (max-width: 364px) {
  .nav-logo {
    width: 6.6rem;
    margin-top: 20px;
  }
}

@media (max-width: 410px) {
  .nav-list {
    margin: 0 auto !important;
  }
}
</style>
